import React from 'react';
// import "./format1.css"

const Format1 = ({ modifyForm = {} }) => {
  // Default columns configuration
  const defaultColumns = [
    { name: "Invoice No.", check: true },
    { name: "Item Description", check: true },
    { name: "Type", check: true },
    { name: "Qty", check: true },
  ];

  // Function to flatten columns structure
  const getVisibleColumns = (columns) => {
    let result = [];

    columns.forEach(col => {
      // If column has children and parent is selected (check: true)
      if (col.select && col.select.length > 0 && col.check) {
        // Add children that are selected (check: true)
        col.select.forEach(child => {
          if (child.check) {
            result.push(child);
          }
        });
      }
      // If column doesn't have children and is selected (check: true)
      else if (!col.select && col.check) {
        result.push(col);
      }
    });
    return result;
  };

  // Merge with modifyForm prop if provided
  const columns = modifyForm?.lr_table?.length > 0 ? modifyForm.lr_table : defaultColumns;

  // Get only visible columns (handling parent-child relationship)
  const visibleColumns = getVisibleColumns(columns);

  // Sample data for demonstration
  const sampleData = [
    {
      "Invoice Number": "INV-001",
      "Field 2": "Value 1",
      "Field 3": "Value 2",
      "Eway Bill Number": "EWB-001",
      "LR Date": "25/05/2024",
      "QTY": "10",
      "KOT": "KOT-001",
      "Weight": "100kg",
      "Sales Value": "$1000"
    },
    // Add more sample data as needed
  ];

  return (
    <>
      <style>
        {` .invoice-box {
            font-size: 12px;
            line-height: 16px;
            font-family: 'Roboto', sans-serif;
            color: #222;
            padding: 0px;
        }

        table {
        border-bottom: 0px;
        }

        .height_410 {
            position: relative;
        }

        table.border_t_b.Extra_p.p_b_0 td {
            padding-bottom: 5px !important;
        }

        .overly_table tr:last-child td {
            border-bottom: none;
        }

        .address_outer p {
            height: 30px;
            margin-bottom: 5px !important;
        }

        .bold_text {
            font-weight: bold;
        }

        .trip_no_detailsa {
            position: absolute;
            bottom: -30px;
            font-size: 10px;
        }

        .border_box {
            border: 1px solid #cccc;
        }

        .termsand_condiotn_relative {
            position: relative;
        }

        .p_0 {
            padding: 0px !important;
        }

        .Gst_in {
            font-weight: 900 !important;
        }

        .Extra_p td {
            padding: 5px 10px !important;
        }

        .address_outer p {
            margin: 0;
        }

        .Extra_p {
            border-top: 1px solid #ccc;
            position: relative;
        }

        .Signature_height {
            height: 2.3cm;
        }

        .invoice-box table {
            width: 100%;
            text-align: left;
            border-collapse: collapse;
        }

        .top_heading p {
            margin-top: 0px;
            margin-bottom: 0px;
            font-size: 11px;
            font-weight: 400;
            line-height: 16px;
        }

        .top_heading .h1 {
            margin: 0;
            font-size: 20px !important;
            margin-bottom: 0;
            margin-top: 0;
            font-weight: bold;
        }

        .left_table {
            border-right: 1px solid #ccc;
        }

        .invoice-box table td {
            vertical-align: top;
        }

        .text-left {
            text-align: left;
        }

        .border_table thead td {
            font-weight: bold;
            padding: 2px 5px;
            font-size: 12px;
        }

        .top_heading {
            padding: 6px 0 4px 15px;
        }

        span.number-with-bg {
            line-height: 16px;
            width: 16px;
            height: 16px;
            display: inline-block;
            background-color: #000 !important;
            color: #fff !important;
            text-align: center;
            border-radius: 30px;
            margin-left: 4px;
            margin-top: -30px;
            -webkit-print-color-adjust: exact;
        }

        .invoice-box table tr.information table td {
            padding-bottom: 40px;
        }

        .invoice-box table tr.heading td {
            background: #eee;
            border-bottom: 1px solid #ddd;
            font-weight: bold;
        }

        .border_table td {
            border: 1px solid #ccc;
            padding: 0px 5px;
        }

        .invoice-box table tr.details td {
            padding-bottom: 20px;
        }

        .Heading_right {
            margin-bottom: 2px !important;
            background: #efefef !important;
            margin: 0;
            padding: 4px 8px;
            font-size: 16px;
            border-bottom: 1px solid #ccc;
            -webkit-print-color-adjust: exact;
            border-top: 1px solid #ccc;
            margin-top: -1px;
            border-right: 1px solid #ccc;
        }

        @media print {
            .Heading_right {
                background: #efefef !important;
                -webkit-print-color-adjust: exact;
                border-top: 1px solid #ccc !important;
            }
        }

        .tfoot_bg td {
            padding: 2px 10px;
            background: #efefef !important;
            font-size: 12px;
            -webkit-print-color-adjust: exact;
        }

        @media print {
            .tfoot_bg td {
                padding: 2px 10px;
                background: #efefef !important;
                font-size: 12px;
                -webkit-print-color-adjust: exact;
            }
        }

        .invoice-box table tr.total td:nth-child(2) {
            border-top: 2px solid #eee;
            font-weight: bold;
        }

        table.table_right thead td {
            padding: 0px;
        }

        .table_right td {
            padding: 2px 10px;
        }

        .termsAndCondiotion {
            font-size: 10px;
            margin-top: 3px;
            margin-bottom: 3px;
        }

        .b_0 {
            border-bottom: 0 !important;
            border-top: 0 !important;
        }

        .width_35 {
            width: 19%;
        }

        .Address {
            height: 26px;
            line-height: 14px !important;
            margin-bottom: 5px !important;
            margin-top: 5px !important;
        }

        table.border_table tr td:nth-child(1) {
            border-left: 0;
            width: 20%;
        }

        table.border_table tr td:nth-child(2) {
            width: 57%;
        }

        table.border_table tr td:nth-child(3) {
            width: 11%;
            border-right: 0px;
        }

        table.border_table tr td:nth-child(4) {
            width: 11%;
        }

        span.bold_text.width_100 {
            width: 100%;
            text-align: center;
            float: left;
        }

        .address_bottom {
            margin: 0;
            height: 38px;
            line-height: 12px;
            padding-top: 0px;
            margin-top: 0px;
            font-size: 10px;
            padding-bottom: 4px;
        }

        .address_bottom p {
            margin-bottom: 0px;
        }

        table.border_table .tfoot_bg td:nth-child(3) {
            border-right: 1px solid #ccc;
        }

        .height_410 {
            height: 328px;
            position: relative;
            font-size: 11px;
            overflow: hidden;
        }

        .height_410 td {
            height: 16.9px;
            line-height: 16.9px;
        }

        .overly_table {
            position: absolute;
            width: 100%;
            top: 0px;
        }

        .fixed_width {
            width: 200px;
            overflow: hidden;
            white-space: nowrap;
            margin-bottom: 0px;
            text-overflow: ellipsis;
        }

        .oP_none {
            opacity: 0;
        }

        .lrCopy_space td {
            padding-top: 4.1px;
            padding-bottom: 5.1px;
        }

        span.poweredby {
            position: absolute;
            bottom: -10px;
            text-align: right;
            width: 100%;
            right: 4px;
            font-size: 9px;
            display: block;
        }

        span.orignal_copy {
            text-align: right;
            float: right;
            font-size: 10px;
            line-height: 17px;
        }

        tr.lrCopy_space.last_tr td {
            padding-bottom: 8px;
        }

        table.border_table.Table_border_none td {
            border-color: #fff;
        }

        .fixed_width {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 250px;
        }

        td.bold_text.text-right.total_div {
            width: 88.5%;
        }

        .sheet.padding-2mm {
            padding: 2mm;
            background: white;
        }

        .sheet-content {
            transform-origin: top left;
            transition: transform 0.2s ease;
            width: 210mm;
            margin: 0 auto;
        }

        @media (max-width: 280px) {
            .sheet-content {
                transform: scale(calc(17% * 2)) !important;
                transform-origin: 5px 0px;
            }
            html {
                overflow: hidden;
            }
        }

        @media (min-width: 281px) and (max-width: 319px) {
            .sheet-content {
                transform: scale(calc(20% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 320px) and (max-width: 339px) {
            .sheet-content {
                transform: scale(calc(20% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 340px) and (max-width: 359px) {
            .sheet-content {
                transform: scale(calc(20% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 360px) and (max-width: 379px) {
            .sheet-content {
                transform: scale(calc(22% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 380px) and (max-width: 399px) {
            .sheet-content {
                transform: scale(calc(24% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 400px) and (max-width: 419px) {
            .sheet-content {
                transform: scale(calc(26% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 420px) and (max-width: 439px) {
            .sheet-content {
                transform: scale(calc(26% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 440px) and (max-width: 459px) {
            .sheet-content {
                transform: scale(calc(28% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 460px) and (max-width: 479px) {
            .sheet-content {
                transform: scale(calc(28.6% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 480px) and (max-width: 499px) {
            .sheet-content {
                transform: scale(calc(30% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 500px) and (max-width: 519px) {
            .sheet-content {
                transform: scale(calc(30% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 520px) and (max-width: 539px) {
            .sheet-content {
                transform: scale(calc(30% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 540px) and (max-width: 559px) {
            .sheet-content {
                transform: scale(calc(33.6% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 560px) and (max-width: 579px) {
            .sheet-content {
                transform: scale(calc(35% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 580px) and (max-width: 599px) {
            .sheet-content {
                transform: scale(calc(36% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 600px) and (max-width: 629px) {
            .sheet-content {
                transform: scale(calc(37.5% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 630px) and (max-width: 669px) {
            .sheet-content {
                transform: scale(calc(38.6% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 670px) and (max-width: 699px) {
            .sheet-content {
                transform: scale(calc(42% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 700px) and (max-width: 739px) {
            .sheet-content {
                transform: scale(calc(44% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 740px) and (max-width: 769px) {
            .sheet-content {
                transform: scale(calc(46% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 770px) and (max-width: 799px) {
            .sheet-content {
                transform: scale(calc(48% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (max-width: 767px) {
            .sheet-content {
                margin: 0 auto;
            }
        }
`}
      </style>

      <div className="A5 landscape">
        <div className="sheet-content">
          <section className="sheet padding-2mm">
            <div className="invoice-box">
              <div className="border_box">
                <table cellPadding="0" cellSpacing="0" style={{ pageBreakAfter: 'always' }}>
                  <tbody>
                    <tr className="top">
                      <td colSpan="2">
                        <table cellPadding="0" cellSpacing="0">
                          <tbody>
                            <tr>
                              <td style={{ width: '65%' }}>
                                <table cellPadding="0" cellSpacing="0" className="left_table">
                                  <thead>
                                    <tr >
                                      <th colSpan="2" >
                                        <div className="top_heading" style={{ textAlign: "left", marginLeft: "10px" }}>
                                          <span className="h1">
                                            {modifyForm?.address || "Company Name"}
                                          </span>
                                          <p className="Address">
                                            <span>
                                              125 sector A scheme no. 78,
                                              indore,
                                              452015
                                            </span>
                                            <span>, +91 9140628760 </span>
                                          </p>
                                          <p className="Gst_in"> GST NO. </p>
                                        </div>
                                      </th>
                                    </tr>
                                  </thead>
                                </table>
                                <div className="height_410">
                                  {/* Dynamic Table Header */}
                                  <table cellPadding="0" cellSpacing="0" className="border_table Table_border_none">
                                    <thead>
                                      <tr>
                                        {visibleColumns.map((column, index) => (
                                          <td key={index}>{column.name}</td>
                                        ))}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {/* Sample Data Rows */}
                                      {sampleData.map((row, rowIndex) => (
                                        <tr key={rowIndex}>
                                          {visibleColumns.map((column, colIndex) => (
                                            <td key={colIndex}>
                                              <span className="oP_none">{row[column.name] || "N/A"}</span>
                                            </td>
                                          ))}
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                  <div className="overly_table">
                                    <table cellPadding="0" cellSpacing="0" className="border_table">
                                      <thead>
                                        <tr>
                                          {visibleColumns.map((column, index) => (
                                            <td key={index}>
                                              <span className="oP_none">{column.name}</span>
                                            </td>
                                          ))}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {[...Array(18)].map((_, i) => (
                                          <tr key={i}>
                                            {visibleColumns.map((column, index) => (
                                              <td key={index}>&nbsp;</td>
                                            ))}
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                                <table cellPadding="0" cellSpacing="0" className="border_table">
                                  <tfoot>
                                    <tr className="tfoot_bg">
                                      <td colSpan={visibleColumns.length - 1} className="bold_text text-right total_div">
                                        Total
                                      </td>
                                      <td className="bold_text">
                                        0
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colSpan={visibleColumns.length} className="b_0" style={{ width: '100%' }}>
                                        <div className="termsand_condiotn_relative">
                                          <h5 className="termsAndCondiotion">Terms & Conditions</h5>
                                          <div className="address_bottom">{modifyForm?.terms_conds}</div>
                                          <p className="trip_no_detailsa">
                                            <b>Trip No</b> - 6026 | <b>ETT Value</b> - 0
                                          </p>
                                          <p className="trip_no_detailsa"></p>
                                        </div>
                                      </td>
                                    </tr>
                                  </tfoot>
                                </table>
                              </td>
                              <td style={{ width: '35%' }}>
                                <table className="table_right" cellPadding="0" cellSpacing="0">
                                  <thead>
                                    <tr>
                                      <td colSpan="4">
                                        <h3 className="Heading_right" style={{ fontSize: '19px', fontWeight: 'bold' }}>
                                          L.R.- 12345<span className="orignal_copy"> ( Original  )
                                            {/* <span className="number-with-bg">1</span> */}
                                          </span>
                                        </h3>
                                      </td>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr className="lrCopy_space last_tr">
                                      <td className="bold_text width_35" style={{ whiteSpace: 'nowrap' }}>
                                        Date
                                      </td>
                                      <td className="text-left width_75" style={{ whiteSpace: 'nowrap', fontWeight: 'bold' }}>
                                        25/05/2024
                                      </td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr className="lrCopy_space last_tr">
                                      <td className="bold_text width_35" style={{ whiteSpace: 'nowrap' }}>
                                        Vehicle No.
                                      </td>
                                      <td className="text-left width_75" style={{ whiteSpace: 'nowrap', fontWeight: 'bold' }}>
                                        MH40BG4590
                                      </td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colSpan="4" className="p_0">
                                        <table cellPadding="0" cellSpacing="0" className="border_t_b Extra_p p_b_0">
                                          <tbody>
                                            <tr>
                                              <td className="bold_text width_35">Consignor</td>
                                              <td className="text-left width_75 bold-text" style={{ fontWeight: 'bold' }}>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colSpan="4" className="p_0">
                                        <table cellPadding="0" cellSpacing="0" className="border_t_b Extra_p">
                                          <tbody>
                                            <tr>
                                              <td className="bold_text width_35">Consignee</td>
                                              <td className="text-left width_75">
                                                <b></b>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td colSpan="2">
                                                <span className="bold_text">Address</span><br />
                                                <div className="address_outer">
                                                  <p className="Sec_address"></p>
                                                  <p className="first_address"></p>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td className="bold_text width_35">Contact</td>
                                              <td className="text-left bold_text width_75"></td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colSpan="4" className="p_0">
                                        <table cellPadding="0" cellSpacing="0" className="border_t_b Extra_p">
                                          <tbody>
                                            <tr>
                                              <td colSpan="2">
                                                <div className="Signature_height"></div>
                                                <span className="bold_text width_100">Consignee Signature</span>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colSpan="4" className="p_0">
                                        <table cellPadding="0" cellSpacing="0" className="border_t_b Extra_p">
                                          <tbody>
                                            <tr>
                                              <td colSpan="2">
                                                <div className="Signature_height"></div>
                                                <span className="bold_text width_100">Godown Keeper's Signature</span>
                                                <span className="poweredby">
                                                  Powered By :<strong>Transport360.in</strong> | Printed on : 04-07-2024 12:05pm
                                                </span>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default Format1;